<template>
    <div class="bggray lc3-painel pt-5">
      <div class="container">
        <div class="row">
          <div class="col"></div>
          <div class="col-5">
            <div class="row mb-4 mx-auto">
              <div class="col text-center"><img src="@/assets/logo.png" class="img-logo text-center"></div>
            </div>
            <h5 class="text-center">Abrir Painel Administrativo</h5>
            <div class="p-3 mt-4 border rounded-3 cardlogin">
              <form @submit.prevent="login">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Username Cliente</label>
                  <input class="form-control" required id="cliente" type="text" placeholder="Cliente" v-model="user.username">
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">Senha do cliente</label>
                  <input class="form-control" id="password" required type="password" placeholder="Senha" v-model="user.password">
                </div>
                <button class="btn btn-primary" type="submit">Entrar</button>
              </form>
            </div>
          </div>
          <div class="col"></div>
        </div>
      </div>
      <!-- Modal Feedback -->
      <div class="modal fade" id="modal_feedback" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Erro ao fazer login!</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>Username ou Password incorretos.</p>
            </div>
          </div>  
        </div>
      </div>
    </div>
</template>

<script>
import http from '@/services/http.js';
import {reactive} from 'vue';
import { useAuth } from '@/services/auth.js';
import router from '@/router';
import { Modal } from "bootstrap";

export default {
  name: 'Login',
  setup(props) {

    const auth = useAuth();
    let modal = '';

    const user = reactive({
      username:'',
      password:''
    });

    const login = async () => {
      try {
        const {data} = await http.post('/login', user);
        auth.setToken(data.token);
        auth.setUser(JSON.stringify({"username":user.username}));
        router.push({name: 'painel'});
      } catch (error) {
        openModal('modal_feedback');
        console.log(error?.response?.data)
      }
    }

    function openModal(elemento) {
      const modalNovoProduto = document.getElementById(elemento);
      modal = new Modal(modalNovoProduto);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    return {user, login}

  }
}
</script>

<style scoped>
  .lc3-painel{
      min-height: 100vh;
      max-height: 100vh;
  }

  .bggray {
    background-color: #e9e9e9;
  }

  .cardlogin  {
    background-color: white;
  }

  .img-logo {
    width: 250px;
  }
</style>